// extracted by mini-css-extract-plugin
export var dividerContainer = "_73-0";
export var line = "_73-1";